import { useIntl } from 'react-intl';

import Footer from '@/components/footer/FooterWrapper';
import Header from '@/components/header/Header';
import Layout from '@/components/layout/LayoutWrapper';
import Loader from '@/components/Loader';
import heroMessages from '@/components/schools/Hero/messages';
import CuratedContent from '@/components/schoolsResources/CuratedContent';
import Guides from '@/components/schoolsResources/Guides';
import Hero from '@/components/schoolsResources/Hero';
import Share from '@/components/schoolsResources/Share';
import ThankYou from '@/components/schoolsResources/ThankYou';
import { useAppLoadedState, useInitState } from '@/hooks/store';
import messages from '@/messages/messages';
import getUrl from '@/utils/getUrl';

const Resources = () => {
	const { formatMessage } = useIntl();
	const appLoaded = useAppLoadedState();

	useInitState();

	return (
		<Layout
			pageName="schools-resources"
			title="Calm"
			customSeo={{
				title: formatMessage(messages.calmSchoolsTitle),
				primaryDescription: `${formatMessage(heroMessages.body)}.`,
				description: `${formatMessage(heroMessages.body)}.`,
				url: `${getUrl('www')}/schools/resources`,
				imageUrl: `${getUrl('www')}/_n/images/social/schools-social.jpg`,
			}}
		>
			<Header isStatic isForSchools />
			<Hero />
			<Guides />
			{appLoaded ? <CuratedContent /> : <Loader color="gray7" />}
			<ThankYou />
			<Share />
			<Footer />
		</Layout>
	);
};

export default Resources;
